<template>
    <OvertimeRequestList :activeTabIndex="1" title="Approved" extraRouteQuery="approved=true" />
</template>

<script>
import OvertimeRequestList from "./overtime-request-list.vue"
export default { components: { OvertimeRequestList } }
</script>
